// extracted by mini-css-extract-plugin
module.exports = {"block":"BlocksManager_block__GcWHL"};